/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";
import { IProblemReasons } from "../../entities/PaymentsStatus/ProblemReasons";

export type TGetPaymentsStatusModel = IModel<
  IGetPaymentsStatusRequest,
  TGetPaymentsStatusResponse
>;

export interface IGetPaymentsStatusRequest {}

export type TGetPaymentsStatusResponse =
  | IGetPaymentsStatusResponse200
  | IGetPaymentsStatusResponse400;

export interface IGetPaymentsStatusResponse200
  extends IModelResponse<IGetPaymentsStatusResponse> {
  statusCode: 200;
}

export interface IGetPaymentsStatusResponse400
  extends IModelResponse<IGetPaymentsStatusResponseError> {
  statusCode: 400;
}

export interface IGetPaymentsStatusResponse {
  /** Глобальный статус платежей в системе **/
  status?: EStatus | null;
  /** Описание проблем с платежами **/
  problemReasons?: IProblemReasons | null;
}

export interface IGetPaymentsStatusResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IGetPaymentsStatusResponse
  | IGetPaymentsStatusResponseError;

export enum EStatus {
  /** Всё хорошо **/
  Ok = "ok",
  /** Ситуация нестабильна **/
  Unstable = "unstable"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetPaymentsStatusResponse): TResponse200;
  400(response: IGetPaymentsStatusResponseError): TResponse400;
}
